
import { HttpClient, HttpBackend } from '@angular/common/http';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { MatTooltipDefaultOptions } from '@angular/material/tooltip';

import { environment } from '../environments/environment';

export function HttpLoaderFactory(http: HttpBackend) {
  const client: HttpClient = new HttpClient(http);

  return new TranslateHttpLoader(client, environment.translationsUrl);
}

export const customTooltipDefaults: MatTooltipDefaultOptions = {
  position: "above",
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 0,
};



